import type { UserAchievements } from '@engage/api-v2-models/extended';
import type { BaseAPI, AxiosPromise } from '../generated/core/request';
import { getUserAchievements as getUserAchievement } from '../generated/services/AchievementsService';

export const getUserAchievementsExtended = (
  api: BaseAPI,
  userId: string,
  imageType?: 'light_image' | 'dark_image',
  acceptLanguage?: string,
  options: any = {},
): AxiosPromise<UserAchievements> =>
  getUserAchievement.apply(this, [api, userId, imageType, acceptLanguage, options]);
